import React, { useState, useEffect, useRef } from 'react';
import csvDownload from 'json-to-csv-export'

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import ReviewComponent from './ReviewComponent';
import ReplyPopUpComponent from './ReplyPopUpComponent';
import EmptyMessageComponent from '../EmptyMessageComponent';
import ClientPlanManagementComponent from '../Client Management/ClientPlanManagementComponent';

import { Select, Option, Stack, Typography, Input, Button, Modal, ModalOverflow, ModalDialog, ModalClose, DialogTitle, DialogContent, Snackbar, Card, Alert, Box, Divider, Chip } from '@mui/joy';
import { Star, Report } from '@mui/icons-material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStore, faMessage, faSearch } from '@fortawesome/free-solid-svg-icons'
import { faGooglePlay, faAppStore } from '@fortawesome/free-brands-svg-icons'

import { cardStyles } from '../../styles/cardStyles';

import DateFilter, { DateFilterValue } from '../Filters/DateFilter';
import { getDateRange } from '../../Helpers/DateHelpers';

import PaginationComponent from '../PaginationComponent';
import WingmanSummary from '../Wingman/WingmanSummary';
import Rating from "@mui/material/Rating"
import { useAuth } from '../../context/authContext';

const networking = require('../../Networking/API');
const helper = require('../../Helpers/helpers');

function ReviewsComponent({ subscription, app }: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [reviews, setReviews] = useState(null) as any[];
    const [reviewToReply, setReviewToReply] = useState<Review>();
    const [openReply, setOpenReply] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showPlanSettings, setShowPlanSettings] = useState(false);
    const [textFilter, setTextFilter] = useState('');
    const [expanded, setExpanded] = React.useState(false);

    //Filter states
    const [currentPage, setCurrentPage] = useState(1);
    const [currentStore, setCurrentStore] = useState('All Sources');
    const [currentSentiment, setCurrentSentiment] = useState('All Sentiments');
    const [currentRating, setCurrentRating] = useState<number>(5);
    const [currentVersion, setCurrentVersion] = useState('All Versions');
    const [currentTerritoryCode, setCurrentTerritoryCode] = useState('All Countries');
    const [selectedFilter, setSelectedFilter] = useState<DateFilterValue>("last7");

    const itemsPerPage = 20;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFisrtItem = indexOfLastItem - itemsPerPage;
    const { start, end } = getDateRange(selectedFilter);
    var versions: any[] = [];
    var territories: any[] = [];

    const hasFetched = useRef(false);

    const huaweiIcon = <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
        <path fill="#e53935" d="M15,6h18c4.971,0,9,4.029,9,9v18c0,4.971-4.029,9-9,9H15c-4.971,0-9-4.029-9-9V15 C6,10.029,10.029,6,15,6z"></path><path fill="#fff" d="M21.775,20.935c-1.506,0-2.669,1.312-2.669,3.716c0,1.571,2.378,5.599,4.486,9.127 C23.592,24.644,23.368,23.655,21.775,20.935z"></path><path fill="#fff" d="M26.225,20.935c-1.624,2.674-1.817,3.711-1.817,12.846c2.108-3.528,4.486-7.558,4.486-9.13 C28.894,22.245,27.731,20.935,26.225,20.935z"></path><path fill="#fff" d="M16.581,23.904c-2.21,1.543-1.484,5.192-0.369,6.386c0.735,0.771,3.596,2.159,6.305,4 L16.581,23.904z"></path><path fill="#fff" d="M31.419,23.904l-5.936,10.385c2.709-1.84,5.57-3.229,6.305-4 C32.903,29.096,33.629,25.447,31.419,23.904z"></path><path fill="#fff" d="M13.612,29.84c0.036,4.111,2.545,5.191,4.241,5.191h4.241L13.612,29.84z"></path><path fill="#fff" d="M34.388,29.84l-8.483,5.191h4.241C31.843,35.031,34.352,33.951,34.388,29.84z"></path><path fill="#fff" d="M15.926,35.775C16.163,37.002,16.698,38,18.239,38c1.542,0,3.035-0.889,3.855-2.225H15.926z"></path><path fill="#fff" d="M25.905,35.775C26.726,37.111,28.219,38,29.761,38s2.076-0.998,2.314-2.225H25.905z"></path><circle cx="14.5" cy="10.5" r="1.5" fill="#b71c1c"></circle><circle cx="33.5" cy="10.5" r="1.5" fill="#b71c1c"></circle><path fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" d="M33.5,10.5c0,0-2,5-9.5,5s-9.5-5-9.5-5"></path>
    </svg>

    useEffect(() => {
        if (!hasFetched.current) {
            getData();
            hasFetched.current = true;
        }
        setExpanded(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStore, currentSentiment, currentRating, currentVersion, currentTerritoryCode, textFilter, selectedFilter]);

    function getData() {
        networking.reviewsFor(app.id, token).then((reviews: any) => {
            setReviews(reviews);
            setLoading(false);
        }).catch((error: Error) => {
            setError(error.message);
            setShowError(true);
            setLoading(false);
        });
    }

    function paginate(page: number) {
        setCurrentPage(page)
    }

    function filterByStore(e: any) {
        e.preventDefault();

        const value = e.target.innerText.trim();

        setCurrentStore(value)
    }

    function filterBySentiment(e: any) {
        e.preventDefault();

        const value = e.target.innerText.trim();

        setCurrentSentiment(value)
    }

    function filterByVersion(e: any) {
        e.preventDefault();

        const value = e.target.innerText;

        setCurrentVersion(value)
    }

    function filterByTerritoryCode(e: any, newValue: any) {
        e?.preventDefault();

        const value = newValue || e?.target?.innerText;

        setCurrentTerritoryCode(value)
    }

    function exportToCSV() {
        const name = "feedback_" + new Date().toLocaleDateString();

        const data = {
            data: currentItems,
            filename: name + ".csv"
        }

        csvDownload(data)
    }

    const reviewTapped = (review: Review) => {
        setReviewToReply(review);
        setOpenReply(true);
    }

    const replySent = (event: any) => {
        setOpenReply(false);

        if (event === true) {
            setShowSuccess(event);
            getData();
        } else {
            setShowPlanSettings(true);
        }
    };

    let list = null;

    if (reviews) {
        reviews.sort(function (a: any, b: any) {
            return new Date(b.updated).getTime() - new Date(a.updated).getTime();
        });

        versions = [...new Set(reviews.map((r: any) => r.version))];
        versions.sort(function (a: any, b: any) {
            if (a !== null) {
                return a.localeCompare(b, undefined, { numeric: true });
            }

            return [];

        });
        versions.unshift("All Versions");

        territories = [...new Set(reviews.map((r: any) => r.territorycode).filter(Boolean))];
        territories.sort();
        territories.unshift("All Countries");

        var currentItems = reviews;

        if (currentStore === 'Appstore') {
            currentItems = currentItems.filter((r: any) => r.store === 'applestore');

        } else if (currentStore === 'Playstore') {
            currentItems = currentItems.filter((r: any) => r.store === 'playstore');

        } else if (currentStore === 'App Gallery') {
            currentItems = currentItems.filter((r: any) => r.store === 'appgallery');

        } else if (currentStore === 'Proactive feedback') {
            currentItems = currentItems.filter((r: any) => r.store === 'profeed');
        }

        currentItems = currentItems.filter((r: Review) => Number(r.rating) <= currentRating);

        if (currentSentiment !== 'All Sentiments') {
            currentItems = currentItems.filter((r: Review) => r.sentiment.toLowerCase() === currentSentiment.toLowerCase());
        }

        if (currentVersion !== 'All Versions') {
            currentItems = currentItems.filter((r: any) => r.version === currentVersion);
        }

        if (currentTerritoryCode !== 'All Countries') {
            currentItems = currentItems.filter((r: any) => r.territorycode === currentTerritoryCode);
        }

        if (textFilter.length !== 0) {
            currentItems = currentItems.filter((r: any) => r.content.toLowerCase().includes(textFilter.toLocaleLowerCase()))
        }

        //Apply Date filters
        currentItems = currentItems.filter((review: Review) => {
            const reviewDate = new Date(review.updated);
            return (!start || reviewDate >= start) && (!end || reviewDate <= end);
        });

        var parsedReviews = currentItems.slice(indexOfFisrtItem, indexOfLastItem);

        list = parsedReviews.map((review: Review, index: number) =>
            <div
                className='mb-3'
                key={index}>
                <ReviewComponent
                    subscription={subscription}
                    app={app}
                    review={review}
                    tokens={[]}
                    canReply={review.store !== 'profeed'}
                    canShare={(app.slack_webhook_url || app.teams_webhook_url) ? true : false}
                    handler={reviewTapped} />
            </div>
        )
    }

    const updateSubscription = (subscription: any) => {
    }

    return (
        <div>
            {/* Plan Modal */}
            <Modal
                open={showPlanSettings}
                onClose={() => setShowPlanSettings(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        size="sm"
                        variant="plain">
                        <ModalClose />
                        <DialogTitle>
                            Plans & Billing
                        </DialogTitle>
                        <DialogContent>
                            Upgrade your plan to reply to reviews.
                        </DialogContent>
                        <div className='pt-4'>
                            <ClientPlanManagementComponent
                                subscription={subscription}
                                onSubscriptionUpdate={updateSubscription}
                            />
                        </div>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>

            {showSuccess &&
                <Snackbar
                    variant="soft"
                    color="success"
                    open={showSuccess}
                    onClose={() => setShowSuccess(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowSuccess(false)}
                            size="sm"
                            variant="soft"
                            color="success"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    Reply sent. 🚀
                </Snackbar>
            }
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {/* Review reply Modal */}
            <Modal
                open={openReply}
                onClose={() => setOpenReply(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        layout="center"
                        size="md"
                        variant="plain"
                        sx={{
                            maxWidth: 800
                        }}>
                        <ModalClose />
                        <DialogTitle>
                            Reply to this review
                        </DialogTitle>
                        <DialogContent>
                            Choose the tone according to the review you are replying.
                        </DialogContent>
                        <Divider />
                        <>
                            <ReplyPopUpComponent
                                subscription={subscription}
                                app={app}
                                review={reviewToReply}
                                handler={replySent} />
                        </>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>
            <div>
                {loading ?
                    <LoadingSpinnerComponent />
                    :
                    <div className='col-lg'>
                        {/* Filters and Actions */}
                        <Box
                            component='section'
                            color='primary'
                            sx={{
                                marginBottom: 2,
                            }}>
                            <div className='row g-2'>
                                <div className='col'>
                                    <Input
                                        type="text"
                                        size='sm'
                                        placeholder="Search..."
                                        sx={{
                                            borderRadius: '10px',
                                            padding: '0 12px',
                                            height: '30px',
                                            backgroundColor: '#ffffff',
                                            fontSize: '12px',
                                            width: '75%',
                                        }}
                                        startDecorator={
                                            <FontAwesomeIcon icon={faSearch} />
                                        }
                                        onChange={(event) => setTextFilter(event.target.value)}
                                    />
                                </div>
                                <div className='col-auto'>
                                    <Select
                                        color="neutral"
                                        defaultValue={'all'}
                                        size="sm"
                                        onChange={filterByStore}
                                        sx={{
                                            borderRadius: '10px',
                                            padding: '0 12px',
                                            height: '30px',
                                            backgroundColor: '#ffffff',
                                            fontSize: '12px',
                                        }}>
                                        <Option value="all">
                                            <span className="me-2"><FontAwesomeIcon icon={faStore} /></span>
                                            All Sources
                                        </Option>
                                        <Option value="apple">
                                            <span className="me-2"><FontAwesomeIcon icon={faAppStore} />
                                            </span> Appstore
                                        </Option>
                                        <Option value="google">
                                            <span className="me-2">
                                                <FontAwesomeIcon icon={faGooglePlay} />
                                            </span> Playstore
                                        </Option>
                                        <Option value="appgallery">
                                            <span className="me-2">
                                                {huaweiIcon}
                                            </span> App Gallery
                                        </Option>
                                        <Option value="proactive">
                                            <span className="me-2">
                                                <FontAwesomeIcon icon={faMessage} />
                                            </span>
                                            Proactive feedback
                                        </Option>
                                    </Select>
                                </div>
                                <div className='col-auto'>
                                    <Select
                                        color="neutral"
                                        defaultValue={'all'}
                                        size="sm"
                                        variant="outlined"
                                        onChange={filterBySentiment}
                                        sx={{
                                            borderRadius: '10px',
                                            padding: '0 12px',
                                            height: '30px',
                                            backgroundColor: '#ffffff',
                                            fontSize: '12px',
                                        }}
                                        renderValue={(selected) =>
                                            selected && (
                                                <Chip
                                                    size='sm'
                                                    color='primary'
                                                    variant="soft">
                                                    {selected.label}
                                                </Chip>
                                            )
                                        }>
                                        <Option value="all">
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Chip
                                                    size='sm'
                                                    color='primary'
                                                    variant="soft">
                                                    All Sentiments
                                                </Chip>
                                            </Stack>
                                        </Option>
                                        <Option value="good">
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Chip
                                                    size='sm'
                                                    color='success'
                                                    variant="soft">
                                                    Good
                                                </Chip>
                                            </Stack>
                                        </Option>
                                        <Option value="neutral">
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Chip
                                                    size='sm'
                                                    color='warning'
                                                    variant="soft">
                                                    Neutral
                                                </Chip>
                                            </Stack>
                                        </Option>
                                        <Option value="bad">
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Chip
                                                    size='sm'
                                                    color='danger'
                                                    variant="soft">
                                                    Bad
                                                </Chip>
                                            </Stack>
                                        </Option>
                                    </Select>
                                </div>
                                <div className='col-auto'>
                                    <Select
                                        color="neutral"
                                        placeholder="All versions"
                                        size="sm"
                                        variant="outlined"
                                        onChange={filterByVersion}
                                        sx={{
                                            borderRadius: '10px',
                                            padding: '0 12px',
                                            height: '30px',
                                            backgroundColor: '#ffffff',
                                            fontSize: '12px',
                                        }}>
                                        {
                                            versions.reverse().map((version: string) => {
                                                return (
                                                    <Option
                                                        key={version}
                                                        value={version}>
                                                        {version}
                                                    </Option>
                                                );
                                            })
                                        }
                                    </Select>
                                </div>
                                <div className='col-auto'>
                                    <Select
                                        color="neutral"
                                        placeholder="All countries"
                                        size="sm"
                                        variant="outlined"
                                        onChange={(_, newValue) => filterByTerritoryCode(null, newValue)}
                                        sx={{
                                            borderRadius: '10px',
                                            padding: '0 12px',
                                            height: '30px',
                                            backgroundColor: '#ffffff',
                                            fontSize: '12px',
                                        }}>
                                        {
                                            territories.map((territory: string) => {
                                                return (
                                                    <Option key={territory} value={territory}>
                                                        {territory === 'All' ? territory : helper.getCountryName ? helper.getCountryName(territory) : territory}
                                                    </Option>
                                                );
                                            })
                                        }
                                    </Select>
                                </div>
                                <div className='col-auto'>
                                    <Select
                                        value={currentRating || 5}
                                        color="neutral"
                                        size="sm"
                                        variant="outlined"
                                        placeholder="Filter by rating"
                                        onChange={(_, newValue) => setCurrentRating(newValue ?? 5)}
                                        renderValue={(selected) =>
                                            selected ? (
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <Rating
                                                        value={Number(selected.value)}
                                                        readOnly size="small"
                                                        emptyIcon={<Star
                                                            style={{ opacity: 0.55 }}
                                                            fontSize="inherit" />} />
                                                </Stack>
                                            ) : (
                                                "Filter by rating"
                                            )
                                        }
                                        sx={{
                                            borderRadius: '10px',
                                            padding: '0 12px',
                                            height: '30px',
                                            backgroundColor: '#ffffff',
                                            fontSize: '12px',
                                        }}>
                                        {[5, 4, 3, 2, 1].map((rating) => (
                                            <Option
                                                key={rating}
                                                value={rating}>
                                                <Stack direction="row"
                                                    spacing={1}
                                                    alignItems="center">
                                                    <Rating
                                                        value={rating}
                                                        readOnly size="small"
                                                        emptyIcon={<Star
                                                            style={{ opacity: 0.55 }}
                                                            fontSize="inherit" />} />
                                                </Stack>
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                                <div className='col-auto'>
                                    <DateFilter
                                        selectedFilter={selectedFilter}
                                        onChange={setSelectedFilter} />
                                </div>
                            </div>
                        </Box>
                        {app && subscription && (subscription.plan === 'AAA' || subscription.plan === 'U') &&
                            <WingmanSummary
                                expanded={expanded}
                                setExpanded={setExpanded}
                                app={app}
                                count={currentItems && currentItems.length}
                            />
                        }
                        {app && subscription && (subscription.plan === 'AA') &&
                            <Alert
                                className="mb-3 mt-3"
                                size="lg"
                                variant="soft"
                                color="primary"
                                endDecorator={
                                    <Button
                                        size="sm"
                                        variant="soft"
                                        color="primary"
                                        onClick={() => setShowPlanSettings(true)}
                                    >
                                        See plans
                                    </Button>
                                }
                            >
                                <div>
                                    <strong>Activate the Wingman</strong>
                                    <Typography level="body-sm">
                                        Wingman provides clear, practical guidance and smart summaries of user reviews to help you improve your app based on real feedback.
                                    </Typography>
                                    <Typography level="body-sm">
                                        This feature is available on the <b>Growth</b> and <b>Premium</b> plans.
                                    </Typography>
                                </div>
                            </Alert>
                        }
                        {/* Reviews */}
                        <Card
                            sx={{
                                ...cardStyles.base
                            }}>
                            {parsedReviews && parsedReviews.length === 0 &&
                                <EmptyMessageComponent
                                    title={'No reviews found.'}
                                    description={'We\'ve not found any reviews. Please try another search criteria.'} />
                            }
                            {parsedReviews && parsedReviews.length !== 0 &&
                                <div className='row'>
                                    <div className='col-auto my-auto px-4'>
                                        <Typography
                                            level='body-xs'
                                            fontWeight={600}
                                            textColor="#a1a1a1">
                                            {currentItems && currentItems.length} reviews found.
                                        </Typography>
                                    </div>
                                    <div className='col'>
                                        {subscription && subscription.plan !== 'A' &&
                                            <div className='text-end'>
                                                <Button
                                                    variant="soft"
                                                    size='sm'
                                                    color="neutral"
                                                    loading={loading}
                                                    onClick={() => exportToCSV()}>
                                                    Export to csv
                                                </Button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <Divider />
                            <div>
                                {list}
                            </div>
                            <div className='m-3'>
                                <PaginationComponent
                                    itemsPerPage={itemsPerPage}
                                    totalItems={currentItems && currentItems.length}
                                    paginate={paginate}
                                    currentPage={currentPage} />
                            </div>
                        </Card>
                    </div>
                }
            </div>
        </div >
    )
}

export default ReviewsComponent;